import useI18n from '../../../i18n/useI18n'
import general from '../../../utils/general'
import './UniversityInfo.scss'
import React from 'react'


const UniversityInfo = ({ university }) => {
  const { t, language } = useI18n()
  if (!university) return null
  const cityName =
    (typeof university.city === 'string' ? university.city : null) ||
    university?.city?.cityName ||
    university?.cityName ||
    ''

  return (
    <div className="university-info-section">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="info-content">
              <h2 className="info-title">
                {general.getLocaleValue(university, 'name', language)}
              </h2>
              <div className="info-text">
                {university.description ? (
                  <div
                    className="description-content"
                    dangerouslySetInnerHTML={{ __html: university.description }}
                  />
                ) : (
                  <p>
                    ...
                  </p>
                )}

              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="video-container">
              {university.videoUrl ? (
                <div className="video-wrapper">
                  <iframe
                    src={university.videoUrl}
                    title="Üniversite Tanıtım Videosu"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              ) : (
                <div
                  className="video-thumbnail"
                  style={{
                    backgroundImage: university.videoThumbnailUrl
                      ? `url(${university.videoThumbnailUrl})`
                      : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                  }}
                >
                  <div className="video-play-button">
                    <i className="zmdi zmdi-play"></i>
                  </div>
                  {university.name && (
                    <div className="video-overlay-text">
                      {general.getLocaleValue(university, 'name', language).toUpperCase()}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UniversityInfo

